// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__Toxrl","modal":"Modal_modal__bPYEG","slide-down":"Modal_slide-down__IJLSY"};